{
  "title": "Year Management",
  "passwordGate": {
    "title": "Re-enter your password",
    "description": "To view year management, enter your password.",
    "label": "Password",
    "submit": "Continue"
  },
  "frozenBanner": "The system is temporarily frozen for a year-management operation",
  "columns": {
    "year": "Year",
    "backup": "Backup",
    "archive": "Archive migration",
    "reset": "Reset the year"
  },
  "status": {
    "verified": "Verified",
    "notDone": "Not done",
    "running": "Running...",
    "failed": "Failed"
  },
  "actions": {
    "backup": "Download Backup",
    "archive": "Migrate the Year to the Archive",
    "reset": "Reset the Year",
    "download": "Download"
  },
  "operationsHistory": {
    "title": "Operations history",
    "empty": "No operations yet",
    "columns": {
      "year": "Year",
      "kind": "Kind",
      "status": "Status",
      "startedBy": "Started by",
      "startedAt": "Started at",
      "finishedAt": "Finished at",
      "sha256": "Fingerprint (SHA-256)"
    }
  },
  "kind": {
    "BACKUP": "Backup",
    "ARCHIVE_MIGRATION": "Archive migration",
    "RESET": "Reset"
  },
  "opStatus": {
    "RUNNING": "Running",
    "SUCCEEDED": "Succeeded",
    "FAILED": "Failed"
  },
  "confirm": {
    "passwordLabel": "Password",
    "backupTitle": "Download a backup of year {{year}}?",
    "backupDescription": "A full database backup for year {{year}} will be created with a verification fingerprint. It can be re-downloaded later.",
    "backupConfirm": "Download",
    "archiveTitle": "Migrate year {{year}} to the archive?",
    "archiveDescription": "Every record of year {{year}} will be copied to the archive environment and verified by row counts and money control totals.",
    "archiveConfirm": "Migrate",
    "resetTitle": "Reset year {{year}}?",
    "resetDescription": "Year {{year}}'s transactions will be archived and removed from the operating system. Users, groups, services, settings, prices, categories and branch business dates are kept. Debtor accounts and vehicles are kept, and debtor balances carry into the new year as opening balances. This action cannot be undone.",
    "resetConfirm": "Reset",
    "resetDisabledReason": "Requires a verified backup and a verified archive migration of this year first"
  },
  "download": {
    "title": "Download backup",
    "description": "Enter your password to download this backup.",
    "confirm": "Download"
  },
  "toasts": {
    "backupStarted": "Backup started",
    "archiveStarted": "Archive migration started",
    "resetStarted": "Reset started",
    "operationSucceeded": "The operation completed successfully",
    "operationFailed": "The operation failed"
  }
}
